<div class="caja-producto d-flex flex-row align-items-baseline m-1">
  <div class="caja-foto">
    <img src="{{IMG_URL}}/thumbs/{{articulo.referencia}}.{{IMG_EXTENSION}}" alt="{{articulo.referencia}}" height="60px"
      class="" style="cursor: pointer;" onerror="this.src='assets/img/no-image.png';">
  </div>
  @if (authService.isLoggedIn()) {
  <div class="btn btn-sm rounded-circle btn-lista mr-4" (click)=lista(articulo)><i class="fa "
      [ngClass]="{'fa-heart-o': articulo.lista_pedcl_id === null, 'fa-heart': articulo.lista_pedcl_id !==null }"></i>
  </div>
  }
  <div class="caja-descripcion" title="{{articulo.descripcion}}">
    {{articulo.descripcion}}
  </div>
</div>